import { createSlice } from "@reduxjs/toolkit";

const diplomSlice = createSlice({
  name: "diploms",
  initialState: {
    isFetching: false,
    diploms: [],
    error: []
  },
  reducers: {
    statusDiplomStart: (state) => {
      state.isFetching = false
      state.error = []
    },
    statusDiplomSuccess: (state, action) => {
      state.isFetching = false
      state.diploms = action.payload
      state.error = []
    },
    statusDiplomFailure: (state, action) => {
      state.isFetching = false
      state.error = action.payload
    }
  }
})


export const { 
  statusDiplomStart,
  statusDiplomSuccess,
  statusDiplomFailure 
} = diplomSlice.actions

export default diplomSlice.reducer